import CRUDService from './CRUDService';

class UserService extends CRUDService {
  constructor(path) {
    super(path);
  }
}

export default new UserService('users');
